import React from 'react';
import PropTypes from 'prop-types';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import classnames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import { colors, fontSize } from '../../constants/styleConstants';

const useStyles = makeStyles({
  root: {
    borderRadius: '8px',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.1)',
    border: `solid 1px ${colors.border.grey}`,
    display: 'flex',
    alignItems: 'center',
    padding: '13px',
  },
  button: {
    boxShadow: 'none',
    border: 0,
    background: 0,
    marginLeft: 'auto',
    fontSize: fontSize.medium,
    fontWeight: 'bold',
    color: colors.blueChip,
    cursor: 'pointer',
  },
  arrow: {
    fontSize: '1.1rem',
    color: colors.blueChip,
    marginLeft: 'auto',
    cursor: 'pointer',
  },
});

const MoreButton = ({ buttonText, className, action }) => {
  const classes = useStyles();

  return (
    <div className={classnames(classes.root, className)}>
      <button type="button" className={classes.button} onClick={() => action()}>
        {buttonText}
      </button>
      <ArrowForwardIcon className={classes.arrow} onClick={() => action()} />
    </div>
  );
};

MoreButton.propTypes = {
  action: PropTypes.func,
  className: PropTypes.string,
  buttonText: PropTypes.string,
};

export default MoreButton;
